// NPM
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';

// Components
import RecommendationActionButton from './RecommendationActionButton';

class RecommendationHideButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false,
    };
  }

  getButtonText = () => {
    const { is_hidden } = this.props.recommendation;
    const { hovered } = this.state;

    if (is_hidden && hovered) {
      return 'Unhide';
    } else if (is_hidden) {
      return 'Hidden';
    } else {
      return 'Hide';
    }
  };

  handleMouseEnter = () => {
    this.setState({ hovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ hovered: false });
  };

  hideRecommendation = () => {
    const { recommendation, hideRecommendation } = this.props;
    hideRecommendation(recommendation);
  };

  render() {
    const buttonText = this.getButtonText();
    return (
      <RecommendationActionButton
        className={`RecommendationHideButton ${buttonText}`}
        onClick={this.hideRecommendation}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {buttonText}
      </RecommendationActionButton>
    );
  }
}

function mapStateToProps(state) {
  return {
    hidingRecommendation: state.hidingRecommendation,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      hideRecommendation: actions.hideRecommendation,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(
  RecommendationHideButton
);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/RecommendationHideButton.js